var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93651 5.25732H28.0635C28.3133 5.25732 28.5159 5.45964 28.5159 5.70922V22.547C28.5159 22.7966 28.3133 22.9989 28.0635 22.9989H3.93651C3.68667 22.9989 3.48413 22.7966 3.48413 22.547V5.70922C3.48413 5.45964 3.68667 5.25732 3.93651 5.25732ZM27.6111 22.0951V6.16111H4.38891V22.0951H27.6111Z",
    fill: "#00807B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0171 26.5089H17.9832V22.5474H14.0171V26.5089Z",
    fill: "#00807B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2712 26.2222C23.521 26.2222 23.7235 26.4245 23.7235 26.6741C23.7235 26.909 23.5441 27.102 23.3147 27.1239L23.2712 27.126H8.72893C8.47909 27.126 8.27655 26.9236 8.27655 26.6741C8.27655 26.4392 8.45596 26.2461 8.68536 26.2242L8.72893 26.2222H23.2712Z",
    fill: "#00807B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0712 13.6584L11.2561 14.4818C10.5419 15.2035 10.5419 16.3848 11.2561 17.106L11.2569 17.1073C11.9709 17.828 13.1397 17.828 13.8532 17.1068L15.6687 15.2718V15.2746C15.8214 15.1491 16.0401 15.1491 16.193 15.2746H16.1955L14.6319 13.694C13.9271 12.9811 12.791 12.9695 12.0717 13.6586",
    fill: "#00807B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7364 14.5177L17.3178 11.146L17.3155 11.144C17.2705 11.0993 17.2231 11.0579 17.1745 11.0186C16.4458 10.4327 15.3627 10.4746 14.6848 11.1435C14.6727 11.1552 14.6611 11.1668 14.6503 11.1785L14.5471 11.28L12.0893 13.7041H12.0898C12.8187 13.0227 13.9698 13.0342 14.6843 13.7391L16.269 15.3018L18.1047 17.1126C18.8284 17.8262 20.0124 17.8262 20.7367 17.1126C21.461 16.3987 21.4602 15.231 20.7364 14.5174",
    fill: "#00B1AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.36887ce06caa20534bb8bbde025fdd8a.svg";
export { ForwardRef as ReactComponent };